import { BookingTypeEnum } from "@/graphql/types"

export type Holidays =
  | "all"
  | "sommerferien"
  | "herbstferien"
  | "weihnachtsferien"
  | "faschingsferien"
  | "osterferien"
  | "pfingstferien"

export const allBookingTypes = [
  BookingTypeEnum.Standard,
  BookingTypeEnum.Vacation_1,
  BookingTypeEnum.Vacation_2,
  BookingTypeEnum.Vacation_3,
  BookingTypeEnum.ShortTime,
]

export const vacationTypes = [
  BookingTypeEnum.Vacation_1,
  BookingTypeEnum.Vacation_2,
  BookingTypeEnum.Vacation_3,
]
export const leftHolidays: Holidays[] = ["sommerferien", "herbstferien", "weihnachtsferien"]
export const rightHolidays: Holidays[] = ["faschingsferien", "osterferien", "pfingstferien"]
export const holidaysList: Holidays[] = [...leftHolidays, ...rightHolidays]

export function isVacationBooking(type: BookingTypeEnum) {
  return (
    !!type &&
    [BookingTypeEnum.Vacation_1, BookingTypeEnum.Vacation_2, BookingTypeEnum.Vacation_3].includes(
      type
    )
  )
}
